import getTestgroup from './testgroup'

const camelize = str => str.replace(/\W+(.)/g, (match, char) => char.toUpperCase())

const transformAttributeKey = value => {
  const pattern = /^data-/

  if (!value.name.match(pattern)) {
    return
  }

  const cleaned = value.name.replace(pattern, '')
  return camelize(cleaned)
}

const getWidgetAttributes = widgetInstance => {
  const attributes = (widgetInstance && widgetInstance.node && widgetInstance.node.attributes) || {}
  let organizedAttributes = {}

  try {
    Object.keys(attributes).forEach(key => {
      const transformedKey = transformAttributeKey(attributes[key])
      if (transformedKey) {
        organizedAttributes[transformedKey] = attributes[key].nodeValue || null
      }
    })
  } catch (ignore) {
    // ignore error and take what we got so far
  }

  return organizedAttributes
}

const getSdkConfig = widgetInstance => ({
  eternalId: widgetInstance.eternalId,
  testgroup: getTestgroup(),
  sdkVersion: window._8select.config.version,
})

const getWidgetConfig = widgetInstance => ({
  widget: { ...getWidgetAttributes(widgetInstance), ...getSdkConfig(widgetInstance) },
})

export default getWidgetConfig
